import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@mui/material';

export const SignupButton = (props: ButtonProps) => {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: window.location.origin,
      },
      authorizationParams: {
        prompt: 'login',
        screen_hint: 'signup',
      },
    });
  };

  return (
    <Button variant={'contained'} onClick={handleSignUp} {...props}>
      Zaregistrovat se
    </Button>
  );
};
